{
  "title": "How to keep your judge profile and see your score history",
  "description": "Maintain your organization, title, expertise and bio yourself, and review the scores you have submitted across competitions.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "After this, the organizer sees your own latest details in the judge list, and you can look back over every score you have submitted in one place.",
  "roleNote": "Judge",
  "prerequisites": ["You have accepted a judge invitation and signed in"],
  "pathLabel": "Judging assignments → My judge profile / Score history",
  "steps": [
    {
      "title": "1. Open \"My judge profile\"",
      "description": "Click \"My judge profile\" at the top of your assignments page. The profile is kept per competition; if you judge several competitions, switch between them at the top of the page. Your name and email belong to your account and are changed under \"Account & security\" in the account menu."
    },
    {
      "title": "2. Fill it in and save",
      "description": "Add your organization, title, expertise (comma separated) and a short bio, then press \"Save\". This is shown only to that competition's organizers (judge list), never to participants or other judges."
    },
    {
      "title": "3. Read announcements",
      "description": "The \"Announcements\" block on your assignments page shows the organizer's latest announcements for judges (up to 3). Not every announcement is emailed, so check it from time to time."
    },
    {
      "title": "4. See your score history",
      "description": "Click \"Score history\" on your assignments page. It lists, per competition, the submissions you have submitted with their totals and links, plus how many you have submitted and your average total. Drafts and work not started yet are on your assignments page."
    }
  ],
  "afterward": [
    "The organizer sees your latest organization, title and expertise in the judge list",
    "Score history shows only your own submitted scores, never other judges' data"
  ],
  "nextSteps": "To keep scoring, go back to your assignments page; see \"How to view the submissions assigned to me\".",
  "faq": [
    {
      "q": "I changed organization. Do I need to update every competition?",
      "a": "Yes. The profile is kept per competition, so switch to each competition under \"My judge profile\" and update it."
    },
    {
      "q": "Why are my drafts not in the score history?",
      "a": "The history lists only submitted scores. Drafts and work not started are handled on your assignments page and appear in the history once submitted."
    }
  ]
}
